import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { fetchRole, clearRole } from './roleSlice';
import { getCookie } from '../../utils/storageHelper';

const getUserDataFromCookie = () => {
  try {
    const cookieData = getCookie('userData');
    if (!cookieData) return null;
    
    return typeof cookieData === 'string' ? JSON.parse(cookieData) : cookieData;
  } catch (error) {
    console.warn('Failed to parse userData cookie:', error);
    return null;
  }
};

const savedUser = getUserDataFromCookie();

const initialState = {
  isLoggedIn: !!savedUser,
  support: savedUser,
  loginStatus: 'idle',
  logoutStatus: 'idle',
  error: null,
};

export const login = createAsyncThunk(
  'super-admin/login',
  async (loginCredentials, { dispatch, rejectWithValue }) => {
    try {
      const { email, password } = loginCredentials;
      const { data } = await axiosInstance.post('super-admin/login', { email, password });
      await dispatch(fetchRole());
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Login failed');
    }
  }
);

export const logout = createAsyncThunk('super-admin/logout', async (_, { dispatch }) => {
  try {
    const { data } = await axiosInstance.post('super-admin/logout');
    dispatch(clearRole());
    return data;
  } catch (err) {
    dispatch(clearRole());
    return err.response?.data?.msg;
  }
});

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    resetSupportAuth: (state) => {
        state.isLoggedIn = false;
        state.support = null;
        state.loginStatus = 'idle';
        state.logoutStatus = 'idle';
        state.error = null;
    },
    updateSupportProfileSuccess: (state, action) => {
        if (state.support) {
            state.support = { ...state.support, ...action.payload };
        }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(login.pending, (state) => {
        state.loginStatus = 'loading';
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loginStatus = 'succeeded';
        state.isLoggedIn = true;
        state.error = null;
        state.support = action.payload.data;
      })
      .addCase(login.rejected, (state, action) => {
        state.loginStatus = 'failed';
        state.error = action.payload || 'An error occurred';
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        if (action.payload.login_role === 'SUPPORT') {
           state.isLoggedIn = true;
           state.loginStatus = 'succeeded';
        }
      })
      .addCase(logout.pending, (state) => {
        state.looutStatus = 'loading';
      })
      .addCase(logout.fulfilled, (state) => {
        state.logoutStatus = 'succeeded';
        state.isLoggedIn = false;
        state.support = null;
      })
      .addCase(logout.rejected, (state, action) => { 
        state.logoutStatus = 'failed';
        state.error = action.payload;
        state.isLoggedIn = false; 
        state.support = null;
      });
  },
});

export const supportLoginStatus = (state) => state.support.loginStatus;
export const supportLoginError = (state) => state.support.error;
export const selectIsLoggedIn = (state) => state.support.isLoggedIn;

export const logoutStatus = (state) => state.support.logoutStatus;
export const logoutError = (state) => state.support.error;
export const { resetSupportAuth, updateSupportProfileSuccess } = supportSlice.actions;

export default supportSlice.reducer;